import { useEffect, useState } from "react"
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import "../App.css";
import { Link } from "react-router-dom";


const Veggie = () => {
  const [veggie, setVeggie] = useState([]);

  useEffect(() =>{
    getVeggie()
  },[])


  const getVeggie = async() =>{
    const api = await fetch (`https://api.spoonacular.com/recipes/random?apiKey=${process.env.REACT_APP_API_KEY}&number=9&tags=vegetarian`)
    const data = await api.json();
    setVeggie(data.recipes)
    
  }
  
  return (
    <div>
    <h3  className="popular-h3">Our Vegetarian Picks</h3>

    <Splide options={{
      perPage:3,
      gap:"3rem",
      pagination:false,
      arrows:false,
      drag:"free",
      breakpoints:{
        390:{
          perPage:1,
        }
      }
    }}>
      {veggie.map((recipe) =>{
        return(
              <SplideSlide key={recipe.id}>
                  <div className="card">
                    <Link to={"/recipe/" + recipe.id}>
                        <p className=" p-text ">
                          {recipe.title}
                        </p>
                        <img className=" " src={recipe.image} alt="" />
                    </Link>
                  </div>
              </SplideSlide>
        )
      })}
    </Splide>

    </div>
  )
}

export default Veggie